import React from 'react';
import { GenerateLeadsComponent } from '../../component/leadsComponents/generateLeadsComponent/GenerateLeadsComponent';

export const SalesManageLeadsPage = () => {
    return (
        <>
            <GenerateLeadsComponent />
        </>
    )
}